import { FC } from 'react'

import { EuiSpacer, EuiTextArea } from '@elastic/eui'

import ConfigHeightEuiFormRow from 'components/ConfigHeight/ConfigHeightEuiFormRow'

interface EditSummaryFormProps {
  summaryLabel: string
  summaryPlaceholder: string
  detailsLabel: string
  detailsPlaceholder: string
  summary: string
  details: string
  onSummaryChange: (summary: string) => void
  onDetailsChange: (details: string) => void
}

export const EditSummaryForm: FC<EditSummaryFormProps> = ({ summaryLabel, summaryPlaceholder, summary, detailsLabel, detailsPlaceholder, details, onSummaryChange, onDetailsChange }) => {
  return (
    <>
      <ConfigHeightEuiFormRow height='39%' fullWidth label={summaryLabel}>
        <EuiTextArea fullWidth style={{ height: '100%' }} placeholder={summaryPlaceholder} value={summary} onChange={e => onSummaryChange(e.target.value)} />
      </ConfigHeightEuiFormRow>
      <EuiSpacer size='l' />
      <ConfigHeightEuiFormRow height='59%' fullWidth label={detailsLabel}>
        <EuiTextArea fullWidth style={{ height: '100%' }} placeholder={detailsPlaceholder} value={details} onChange={e => onDetailsChange(e.target.value)} />
      </ConfigHeightEuiFormRow>
    </>
  )
}
